import { render, staticRenderFns } from "./LayoutColumnHeaderBranded.vue?vue&type=template&id=dc9632e8&"
import script from "./LayoutColumnHeaderBranded.vue?vue&type=script&lang=js&"
export * from "./LayoutColumnHeaderBranded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc9632e8')) {
      api.createRecord('dc9632e8', component.options)
    } else {
      api.reload('dc9632e8', component.options)
    }
    module.hot.accept("./LayoutColumnHeaderBranded.vue?vue&type=template&id=dc9632e8&", function () {
      api.rerender('dc9632e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/layout/LayoutColumnHeaderBranded.vue"
export default component.exports